import { useState, useEffect } from "react";
import axios from 'axios'
import { registrarEvento } from "../../analytics";

export function SectionLibroReclamaciones() {

 
  const [token, setToken] = useState("");

  const [inputnombre, cambiarInputNombre] = useState('')
  const handleInputnombre = (e) => {
    cambiarInputNombre(e.target.value);
  }

  const [inputTypeDoc, cambiarInputTypeDoc] = useState('')
  const handleInputTypeDoc = (e) => {
    cambiarInputTypeDoc(e.target.value);
  }

  const [inputDocumento, cambiarInputDocumento] = useState('')
  const handleInputDocumento = (e) => {
    cambiarInputDocumento(e.target.value);
  }

  const [inputApellPa, cambiarInputApellPa] = useState('')
  const handleInputApellPa = (e) => {
    cambiarInputApellPa(e.target.value);
  }

  const [inputApellMa, cambiarInputApellMa] = useState('')
  const handleInputApellMa = (e) => {
    cambiarInputApellMa(e.target.value);
  }

  const [inputEmail, cambiarInputEmail] = useState('')
  const handleInputEmail = (e) => {
    cambiarInputEmail(e.target.value);
  }

  const [inputTele, cambiarInputTele] = useState('')
  const handleInputTele = (e) => {
    cambiarInputTele(e.target.value);
  }


  const [inputEmailApoderado, cambiarInputEmailApoderado] = useState('')
  const handleInputEmailApoderado = (e) => {
    cambiarInputEmailApoderado(e.target.value);
  }

  const [inputTeleApoderado, cambiarInputTeleApoderado] = useState('')
  const handleInputTeleApoderado = (e) => {
    cambiarInputTeleApoderado(e.target.value);
  }



  const [inputDirec, cambiarInputDirec] = useState('')
  const handleInputDirec = (e) => {
    cambiarInputDirec(e.target.value);
  }

  const [inputNomPaMa, cambiarInputNomPaMa] = useState('')
  const handleInputNomPaMa = (e) => {
    cambiarInputNomPaMa(e.target.value);
  }

  const [inputTypeDocPaoMa, cambiarInputTypeDocPaoMa] = useState('')
  const handleInputTypeDocPaoMa = (e) => {
    cambiarInputTypeDocPaoMa(e.target.value);
  }

  const [inputDocPaoMa, cambiarInputDocPaoMa] = useState('')
  const handleInputDocPaoMa = (e) => {
    cambiarInputDocPaoMa(e.target.value);
  }

  const [inputTienFina, cambiarInputTienFina] = useState('')
  const handleInputTienFina = (e) => {
    cambiarInputTienFina(e.target.value);
  }

  const [inputTipoProd, cambiarInputTipoProd] = useState('')
  const handleInputTipoProd = (e) => {
    cambiarInputTipoProd(e.target.value);
  }
  const [inputTipoAsunto, cambiarInputTipoAsunto] = useState('')
  const handleInputTipoAsunto = (e) => {
    cambiarInputTipoAsunto(e.target.value);
  }
  
  const [inputMonto, cambiarInputMonto] = useState('')
  const handleInputMonto = (e) => {
    cambiarInputMonto(e.target.value);
  }

  const [inputCredito, cambiarInputCredito] = useState('')
  const handleInputCredito = (e) => {
    cambiarInputCredito(e.target.value);
  }

  const [inputBoletaF, cambiarInputBoletaF] = useState('')
  const handleInputBoletaF = (e) => {
    cambiarInputBoletaF(e.target.value);
  }
  

  const [inputDesc, cambiarInputDesc] = useState('')
  const handleInputDesc = (e) => {
    cambiarInputDesc(e.target.value);
  }
  const [empresa, ruc, direccion] = useState('')
  const [inputTypeRecl, cambiarInputTypeRecl] = useState('')
  const handleInputTypeRecl = (e) => {
    cambiarInputTypeRecl(e.target.value);
  }

  const [inputDetaRecla, cambiarInputDetaRecla] = useState('')
  const handleInputDetaRecla = (e) => {
    cambiarInputDetaRecla(e.target.value);
  }

  const [mostrarCorreo, setMostrarCorreo] = useState(false);

  const [inputTypeRespuesta, cambiarInputRespuesta] = useState('Fisico')
  const handleInputTypeRespuesta = (e) => {
    cambiarInputRespuesta(e.target.value);

    if(e.target.value=== "Fisico"){
      //cambiarInputEmail ('marcos.velasquez@quetalcompra.com');
       //setMostrarCorreo(false);
    }else{
      //cambiarInputEmail ('');
       //setMostrarCorreo(true);
    }

  }
  

  const [inputPedido, cambiarInputPedido] = useState('')
  const handleInputPedido = (e) => {
    cambiarInputPedido(e.target.value);
  }

  const [inputAdj, cambiarInputAdj] = useState('')
  const [inputName, cambiarInputNameAdju] = useState('')
  const [actualState, changeCheckState] = useState(false);
  const handleInputAdj = e => {

     convertirBase64(e.target.files)
     cambiarInputNameAdju(e.target.files[0].name);

  }
  const [codigoReclamo, cambiarCodigoReclamo] = useState('')

  const [isDisabled, setIsDisabled] = useState(false);
  const [buttonTitle, setButtonTitle] = useState('Submit');


  const [mostrarResumen, setMostrarResumen] = useState(false);


  useEffect(() => {
    const data2 = {
      usuario: "MISCUOTASWeb",
      clave: "12345678",
      tipo: "Web",
      EmpresaId: "10717122938"
    };

    axios.post(`https://miscuotas.com:8901/api`, data2)
      .then(res => {
        setToken(res.data.access_token);
        console.log(res.data.access_token);
      })
  }, [])

  const convertirBase64 = (archivos) => {
    Array.from(archivos).forEach(archivo => {
      var reader = new FileReader();
      reader.readAsDataURL(archivo);
      reader.onload = function () {
        var base64 = reader.result;
        console.log(base64);
        cambiarInputAdj(base64);
      }
    })
  }

  const [eventInstanceId, setEventInstanceId] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();


    setIsDisabled(true);
    setButtonTitle('Enviando...');
    const data3 = {
      reclamoId: 0,
      reclamoTipoDocumento: inputTypeDoc,
      reclamoDocumento: inputDocumento,
      reclamoNombre: inputnombre,
      reclamoApePaterno: inputApellPa,
      reclamoApeMaterno: inputApellMa,
      reclamoTipoRespuesta: inputTypeRespuesta,
      reclamoDireccion: inputDirec,
      reclamoTelefono: inputTele,
      reclamoEmail: inputEmail,
      MayorNombre: inputNomPaMa,
      MayorTipoDocumento: inputTypeDocPaoMa,
      MayorDocumento: inputDocPaoMa,
      MayorTelefono: inputTeleApoderado,
      MayorEmail: inputEmailApoderado,
      contratadoTiendaId: inputTienFina,
      contratadoId: inputTipoProd,
      contratadoMonto: inputMonto,
      contratoAsunto:inputTipoAsunto,
      contratoNroCredito:inputCredito,
      contratoNroBolletaF: inputBoletaF,
      detalleTipoReclamo: inputTypeRecl,
      detalleReclamo: inputDetaRecla,
      detallePedido: inputPedido,
      reclamoCanal: "WEB",
      PlantillaId: "27",
      ParametrosCodigo: "SERCLI",
      ParametrosStDring: "",
      Asunto: "Reclamo MisCuotas Caso Nro: ",
    }
    const headers1 = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }

    
    
 
    try {
      const respuesta = await axios.post('https://apiqtc.miscuotas.com/ms-delivery/v2/reclamaciones', data3, { headers: headers1 });

      if (respuesta.status === 200) {
      
        changeCheckState(true);
        setEventInstanceId(respuesta.data.eventInstanceId); // Guardamos el valor en el estado
        setMostrarResumen(true);
      } else {
        console.error('Error al enviar el correo:', respuesta);
      }
    } catch (error) {
      console.error('Error al enviar el correo:', error);
    }  
  }

  return <>

    <section className="section sectionReclamo">
      <article className="container">
        <h2 className="title">Libro de Reclamaciones</h2>
        <p style={{ textAlign: 'justify', fontSize: '1.5rem', fontWeight: 'normal' }}>Las reclamaciones y quejas recibidas en este libro se atenderán en relación a las ventas realizadas bajo la razón social "QTC Servicios Financieros SAC".</p>
        <p style={{ textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold' }}>QTC SERVICIOS FINANCIEROS S.A.C.</p>
        <p style={{ textAlign: 'center', marginBottom: '2.5rem', fontSize: '1.5rem', fontWeight: 'bold' }}>RUC: 20608863762</p>
        <p style={{ textAlign: 'center', marginBottom: '2.5rem', fontSize: '1.5rem', fontWeight: 'bold' }}>Dirección Fiscal: AV. REPUBLICA DE PANAMA NRO. 3623 INT. 2901 URB. EL PALOMAR LIMA - LIMA - SAN ISIDRO</p>
        <div style={{ textAlign: 'justify', fontSize: '1.6rem', fontWeight: 'normal' , backgroundColor:'beige' , padding:'20px' }}>
        <strong>Al amparo del artículo 5 del Reglamento del Libro de Reclamaciones:</strong><br></br>
        En caso que el consumidor no consigne como mínimo su nombre, DNI, domicilio o correo electrónico, fecha del reclamo o queja y el detalle de los mismos, estos se considerarán como no presentados.
        </div>
        
        

        {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} > {eventInstanceId && <h2 ><strong>Número de Ticket de Reclamo:</strong>  #{eventInstanceId}</h2>}</p>
            </div>
            )}



        <form className="reclamacionesForm" onSubmit={handleSubmit}>



          <h3 className="reclamacionesForm__title">1.- Identificación del consumidor reclamante</h3>
      
            
            {!mostrarResumen && (
            <div className="reclamacionesForm__row">
            <select   name="" id="" value={inputTypeDoc} onChange={handleInputTypeDoc} >
              <option value="00" defaultValue hidden>Tipo de documento</option>
              <option value="DNI">DNI</option>
              <option value="PASAPORTE">Pasaporte</option>
            </select>
            <input type="text" placeholder="Numero de documento" value={inputDocumento} onChange={handleInputDocumento}  />
            </div>  )}

            {mostrarResumen && (
              <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Tipo de documento:</strong>  {inputTypeDoc}</p>
            <p style={{display:!mostrarResumen}} ><strong>Número de documento:</strong>  {inputDocumento}</p>
            </div>
            )}

            
          {!mostrarResumen && (
          <div className="reclamacionesForm__row">
            <input type="text" placeholder="Nombres" className="reclamacionesForm__input--span-2" value={inputnombre} onChange={handleInputnombre}  />
          </div>)}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Nombres:</strong>  {inputnombre}</p>
            </div>
            )}


          {!mostrarResumen && (
          <div className="reclamacionesForm__row">
            <input type="text" placeholder="Apellido paterno" value={inputApellPa} onChange={handleInputApellPa}  />
            <input type="text" placeholder="Apellido materno" value={inputApellMa} onChange={handleInputApellMa}  />
          </div>)}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Apellido paterno:</strong>  {inputApellPa}</p>
            <p style={{display:!mostrarResumen}} ><strong>Apellido materno:</strong>  {inputApellMa}</p>
            </div>
            )}
        
        <div>
          <strong> 
         Al momento de ingresar un reclamo o queja virtual dentro de este sitio web, y si ya ha indicado una dirección física, no se encuentra obligado a brindar un correo electrónico dentro del Libro de Reclamaciones Virtual.
         </strong></div>
        
         {!mostrarResumen && (
          <div className="reclamacionesForm__row">
            <select name="" id="" value={inputTypeRespuesta} onChange={handleInputTypeRespuesta} >
              <option value="00"  defaultValue hidden>Tipo de Respuesta</option>
              <option value="Fisico">Domicilio físico</option>
              <option value="Email">Correo electrónico</option>
            </select>
          </div>)}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Tipo de Respuesta:</strong>  {inputTypeRespuesta}</p>
            </div>
            )}


          {!mostrarResumen && (
          <div className="reclamacionesForm__row">
            <input type="email" id="correo" placeholder="Email" value={inputEmail} onChange={handleInputEmail} required={inputTypeRespuesta === 'Email'} />
            <input type="tel" placeholder="Telefono" value={inputTele} onChange={handleInputTele}  />
          </div>)}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Email:</strong>  {inputEmail}</p>
            <p style={{display:!mostrarResumen}} ><strong>Telefono:</strong>  {inputTele}</p>
            </div>
            )}

          {!mostrarResumen && (  
          <div className="reclamacionesForm__row">
            <input type="text" placeholder="Dirección" className="reclamacionesForm__input--span-2" value={inputDirec} onChange={handleInputDirec}  />
          </div>)}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Dirección:</strong>  {inputDirec}</p>
            </div>
            )}

          <h3 className="reclamacionesForm__title">Para el caso de menores de edad</h3>

          {!mostrarResumen && (
          <div className="reclamacionesForm__row">
            <input type="text" placeholder="Nombre de padre o madre" className="reclamacionesForm__input--span-2" value={inputNomPaMa} onChange={handleInputNomPaMa} />
          </div>)}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Nombre de padre o madre:</strong>  {inputNomPaMa}</p>
            </div>
            )}


          {!mostrarResumen && (
          <div className="reclamacionesForm__row">
            <select name="" id="" value={inputTypeDocPaoMa} onChange={handleInputTypeDocPaoMa}>
              <option value="00" defaultValue hidden>Tipo de documento</option>
              <option value="DNI">DNI</option>
              <option value="PASAPORTE">Pasaporte</option>
            </select>
            <input type="text" placeholder="Número de documento" value={inputDocPaoMa} onChange={handleInputDocPaoMa} />
          </div>)}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Tipo de documento:</strong>  {inputTypeDocPaoMa}</p>
            <p style={{display:!mostrarResumen}} ><strong>Número de documento:</strong>  {inputDocPaoMa}</p>
            </div>
            )}


          {!mostrarResumen && (
          <div className="reclamacionesForm__row">
            <input type="emil" placeholder="Email Apoderado" value={inputEmailApoderado} onChange={handleInputEmailApoderado}  />
            <input type="tel" placeholder="Telefono Apoderado" value={inputTeleApoderado} onChange={handleInputTeleApoderado}  />
          </div>
          )}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Email Apoderado:</strong>  {inputEmailApoderado}</p>
            <p style={{display:!mostrarResumen}} ><strong>Telefono Apoderado:</strong>  {inputTeleApoderado}</p>
            </div>
            )}


          <h3 className="reclamacionesForm__title">2.- Información general</h3>


          {!mostrarResumen && ( 
          <div className="reclamacionesForm__row">
            <select value={inputTienFina} onChange={handleInputTienFina} >
              <option value="" defaultValue disabled hidden>Tienda de financiamiento </option>
              <option value="XIAOMI JIRON DE LA UNION">XIAOMI JIRON DE LA UNION</option>
              <option value="XIAOMI CHICLAYO">XIAOMI CHICLAYO</option>
              <option value="XIAOMI STORE COMAS">XIAOMI STORE COMAS</option>
              <option value="XIAOMI CUSCO">XIAOMI CUSCO</option>
              <option value="XIAOMI MALL DEL SUR">XIAOMI MALL DEL SUR</option>
              <option value="XIAOMI MEGA PLAZA">XIAOMI MEGA PLAZA</option>
              <option value="XIAOMI CENTRO CIVICO">XIAOMI CENTRO CIVICO</option>
              <option value="XIAOMI PLAZA NORTE">XIAOMI PLAZA NORTE</option>
              <option value="XIAOMI SANTA ANITA">XIAOMI SANTA ANITA</option>
              <option value="XIAOMI HUANCAYO">XIAOMI HUANCAYO</option>
              <option value="XIAOMI SJL">XIAOMI SJL</option>
              <option value="XIAOMI CHICLAYO 2">XIAOMI CHICLAYO 2</option>
              <option value="XIAOMI MOD PRIMAVERA">XIAOMI MOD PRIMAVERA</option>
              <option value="XIAOMI SALAVERRY">XIAOMI SALAVERRY</option>
              <option value="XIAOMI MODULO SALAVERRY">XIAOMI MODULO SALAVERRY</option>
              <option value="XIAOMI PUCALLPA">XIAOMI PUCALLPA</option>
              <option value="XIAOMI LA MOLINA">XIAOMI LA MOLINA</option>
              <option value="XIAOMI IQUITOS">XIAOMI IQUITOS</option>
              <option value="XIAOMI SAN MIGUEL">XIAOMI SAN MIGUEL</option>
              <option value="XIAOMI PURUCHUCO">XIAOMI PURUCHUCO</option>
              <option value="XIAOMI BELLAVISTA">XIAOMI BELLAVISTA</option>
              <option value="XIAOMI AREQUIPA">XIAOMI AREQUIPA</option>
              <option value="XIAOMI MIRAFLORES">XIAOMI MIRAFLORES</option>
              <option value="HONOR MALL DEL SUR">HONOR MALL DEL SUR</option>
              <option value="HONOR MEGA PLAZA">HONOR MEGA PLAZA</option>
              <option value="HONOR SANTA ANITA">HONOR SANTA ANITA</option>
              <option value="HONOR TRUJILLO">HONOR TRUJILLO</option>
              <option value="HONOR AREQUIPA">HONOR AREQUIPA</option>
              <option value="MODULO HONOR AREQUIPA">MODULO HONOR AREQUIPA</option>
              <option value="HONOR PLAZA NORTE">HONOR PLAZA NORTE</option>
              <option value="HONOR MINKA">HONOR MINKA</option>
              <option value="HONOR PURUCHUCO">HONOR PURUCHUCO</option>
              <option value="HONOR SJL">HONOR SJL</option>
              <option value="HONOR CUSCO">HONOR CUSCO</option>
              <option value="HONOR COMAS">HONOR COMAS</option>
              <option value="HONOR CHICLAYO">HONOR CHICLAYO</option>
              <option value="TEC STORE TRUJILLO">TEC STORE TRUJILLO</option>
              <option value="TEC STORE PLAZA NORTE">TEC STORE PLAZA NORTE</option>
              <option value="TEC STORE IQUITOS">TEC STORE IQUITOS</option>
              <option value="TEC STORE SAN MIGUEL">TEC STORE SAN MIGUEL</option>
              <option value="TEC STORE AREQUIPA">TEC STORE AREQUIPA</option>

              <option value="HIROPHONE - Open Plaza Atocongo Módulo 1">HIROPHONE - Open Plaza Atocongo Módulo 1</option>
              <option value="HIROPHONE - Mall Plaza Comas Módulo 1">HIROPHONE - Mall Plaza Comas Módulo 1</option>
              <option value="HIROPHONE - Mall Plaza Comas Módulo Sótano">HIROPHONE - Mall Plaza Comas Módulo Sótano</option>
              <option value="HIROPHONE - Real Plaza Pro Módulo 1">HIROPHONE - Real Plaza Pro Módulo 1</option>
              <option value="HIROPHONE - Mall Plaza Huancayo Módulo 1">HIROPHONE - Mall Plaza Huancayo Módulo 1</option>
              <option value="HIROPHONE - Mall Plaza Huaycan Tienda 1">HIROPHONE - Mall Plaza Huaycan Tienda 1</option>
              <option value="HIROPHONE - Mall Plaza Huaycan Tienda 2">HIROPHONE - Mall Plaza Huaycan Tienda 2</option>
              <option value="HIROPHONE - Mall Plaza Huaycan Tienda 3">HIROPHONE - Mall Plaza Huaycan Tienda 3</option>
              <option value="HIROPHONE - Real Plaza Puruchuco Módulo 1">HIROPHONE - Real Plaza Puruchuco Módulo 1</option>
              <option value="HIROPHONE - Real Plaza Puruchuco Módulo 2">HIROPHONE - Real Plaza Puruchuco Módulo 2</option>
              <option value="HIROPHONE - Mall Plaza San Juan de Lurigancho Módulo 1">HIROPHONE - Mall Plaza San Juan de Lurigancho Módulo 1</option>
              <option value="HIROPHONE - Mall Plaza San Juan de Lurigancho Módulo 3">HIROPHONE - Mall Plaza San Juan de Lurigancho Módulo 3</option>
              <option value="HIROPHONE - Mall Plaza San Juan de Lurigancho Módulo Sótano">HIROPHONE - Mall Plaza San Juan de Lurigancho Módulo Sótano</option>
              <option value="HIROPHONE - Mall Plaza Santa Anita Módulo 2">HIROPHONE - Mall Plaza Santa Anita Módulo 2</option>
              <option value="HIROPHONE - Mall Plaza Santa Anita Módulo Sótano">HIROPHONE - Mall Plaza Santa Anita Módulo Sótano</option>
              <option value="HIROPHONE - Mall Plaza Santa Anita Tienda 1">HIROPHONE - Mall Plaza Santa Anita Tienda 1</option>
              <option value="HIROPHONE - Real Plaza Santa Clara Módulo 1">HIROPHONE - Real Plaza Santa Clara Módulo 1</option>
              <option value="HIROPHONE - Real Plaza Santa Clara Tienda 1">HIROPHONE - Real Plaza Santa Clara Tienda 1</option>
              <option value="HIROPHONE - Real Plaza Villa María del Triunfo Módulo 1">HIROPHONE - Real Plaza Villa María del Triunfo Módulo 1</option>


            </select>
            <select value={inputTipoProd} onChange={handleInputTipoProd} >
              <option value="" disabled="" hidden="" defaultValue>Tipo de bien contratado *</option>
              <option value="Servicio">Servicio</option>
            </select>
          </div>

          )}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Tienda de financiamiento :</strong>  {inputTienFina}</p>
            <p style={{display:!mostrarResumen}} ><strong>Tipo de bien contratado :</strong>  {inputTipoProd}</p>
            </div>
            )}

        {!mostrarResumen && ( 
          <div className="reclamacionesForm__row">
            <input type="text" placeholder="Monto de reclamo" value={inputMonto} onChange={handleInputMonto}  />
            <select value={inputTipoAsunto} onChange={handleInputTipoAsunto} >
              <option value="" disabled="" hidden="" defaultValue>Asunto          </option>
              <option value="Atencion">Atención</option>
              <option value="Bloqueo">Bloqueo</option>
              <option value="Pagos">Pagos</option>
              <option value="Otros">Otros</option>
            </select>
          </div>
          )}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Monto de reclamo :</strong>  {inputMonto}</p>
            <p style={{display:!mostrarResumen}} ><strong>Asunto :</strong>  {inputTipoAsunto}</p>
            </div>
            )}

          {!mostrarResumen && ( 
          <div className="reclamacionesForm__row">
            <input type="text" placeholder="Número de Crédito" value={inputCredito} onChange={handleInputCredito}  />
            <input type="text" placeholder="Número de Boleta o Factura" value={inputBoletaF} onChange={handleInputBoletaF}  />
          </div>
          )}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Número de Crédito :</strong>  {inputCredito}</p>
            <p style={{display:!mostrarResumen}} ><strong>Número de Boleta o Factura :</strong>  {inputBoletaF}</p>
            </div>
            )}


          <h3 className="reclamacionesForm__title">3.- Detalle de la Reclamación y pedido del consumidor</h3>

          {!mostrarResumen && ( 
          <div className="reclamacionesForm__row">
            <select value={inputTypeRecl} onChange={handleInputTypeRecl} >
              <option value="" disabled="" hidden="" defaultValue>Tipo de reclamo </option>
              <option value="Reclamo">Reclamo</option>
              <option value="Queja">Queja</option>
            </select>
          </div> )}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Tipo de reclamo :</strong>  {inputTypeRecl}</p>
            </div>
            )}

          {!mostrarResumen && (   
          <div className="reclamacionesForm__row">
            <textarea className="reclamacionesForm__input--span-2" name="" id="" cols="30" rows="6" placeholder="Detalles del reclamo" value={inputDetaRecla} onChange={handleInputDetaRecla} ></textarea>
          </div> )}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Detalles del reclamo :</strong>  {inputDetaRecla}</p>
            </div>
            )}

          {!mostrarResumen && (  
          <div className="reclamacionesForm__row">
            <textarea className="reclamacionesForm__input--span-2" name="" id="" cols="30" rows="6" placeholder="Pedido" value={inputPedido} onChange={handleInputPedido} ></textarea>
          </div>)}
          {mostrarResumen && (
            <div className="reclamacionesForm__row">
            <p style={{display:!mostrarResumen}} ><strong>Pedido :</strong>  {inputPedido}</p>
            </div>
            )}


{!mostrarResumen && ( 
  <div>
          <div className="row">
            <div className="col-lg-12">
              <input type="checkbox" name="loffield_c351[]" id="loffield_c351654d0c8be140f0" value="*La formulación del reclamo no impide acudir a otras vías de solución de controversias ni es requisito previo para interponer una denuncia ante el INDECOPI." className="validate-one-required-by-name required-entry"  defaultChecked={true}/>
              <label htmlFor="loffield_c351654d0c8be140f0">*La formulación del reclamo no impide acudir a otras vías de solución de controversias ni es requisito previo para interponer una denuncia ante el INDECOPI.</label>
            </div>
          </div><br></br>
          <div className="row">
            <div className="col-lg-12">
                <input type="checkbox" name="loffield_c351[]" id="loffield_c351654d0c8be140f1" value="* El proveedor debe dar respuesta al reclamo o queja en un plazo no mayor a quince (15) días hábiles, el cual es improrrogable." className="validate-one-required-by-name required-entry"  defaultChecked={true}/>
                <label htmlFor="loffield_c351654d0c8be140f1">* El proveedor debe dar respuesta al reclamo o queja en un plazo no mayor a quince (15) días hábiles, el cual es improrrogable.</label>
            </div>
          </div>
  </div>
)}
        {!mostrarResumen && ( 
          <button type="submit" className="reclamacionesForm__button"  disabled={isDisabled} title={buttonTitle}>{buttonTitle} </button>
        )}
          {mostrarResumen && ( 
            <div>
             
            <button type="button" onClick={() => window.location.reload(false)} className="reclamacionesForm__button"  > Otro Reclamo</button>
            </div>
          )}  
        
        </form>
      </article>
      <input type="checkbox" id="btn-modal" checked={actualState} />
      <div className="container-modal">
        <div className="content-modal">
          <img height="40" src="img/MIS-CUOTAS_fondo blanco.png" className="custom-logo" alt="" />
          <h4>QTC SERVICIOS FINANCIEROS S.A.C.</h4>
          <span>RUC: 20608863762</span>
          <p>Estimado Cliente su Reclamo/Pedido 
            # {eventInstanceId && <strong>{eventInstanceId} </strong>}
             fue registrado correctamente. Brindamos el código del reclamo para su seguimiento <b>{codigoReclamo}</b>. Así mismo le hemos enviado a su correo el detalle del mismo. Gracias por su tiempo.</p>
          <div className="btn-cerrar">
            <label htmlFor="btn-modal" onClick={() => changeCheckState(false)}
          >cerrar</label>
          </div>
        </div>
        <label htmlFor="btn-modal" className="cerrar-modal"></label>
      </div>
    </section>
  </>
   
/*   onClick={() => window.location.reload(false)}
  return <>

    <section className="section sectionReclamo">
      <article className="container">
        <h2 className="title">Optimizando tu experiencia: <br></br>
          Libro de Reclamaciones Temporalmente en Mantenimiento
        </h2>
        <p><i class="fas fa-cog"></i> ¡Estamos mejorando para ti!</p>
        <p>Nuestro libro de Reclamaciones está en mantenimiento. Mientras tanto, puedes registrar tu reclamo en los siguientes enlaces de nuestros comercios afiliados:</p>
        
        <ul className="reclamo">
          <li>
            <strong>Xiaomi:</strong>
            <p>
              <a href="https://xiaomiperu.com/libro-de-reclamaciones" target="_blank"
                 onClick={() => registrarEvento("click_libro_reclamaciones", { destino: "xiaomi" })}>https://xiaomiperu.com/libro-de-reclamaciones</a>
            </p>
          </li>
          <li>
            <strong>Tec Store:</strong>
            <p>
              <a href="https://tecstore.pe/libro-de-reclamaciones" target="_blank"
                 onClick={() => registrarEvento("click_libro_reclamaciones", { destino: "tecstore" })}>https://tecstore.pe/libro-de-reclamaciones</a>
            </p>
          </li>
          <li>
            <strong>Honor:</strong>
            <p>
              <a href="https://honorperu.pe/libro-de-reclamaciones" target="_blank"
                 onClick={() => registrarEvento("click_libro_reclamaciones", { destino: "honor" })}>https://honorperu.pe/libro-de-reclamaciones</a>
            </p>
          </li>
        </ul>

      <p>Agradecemos tu comprensión y paciencia.. Muy pronto tendremos todo listo para ti.</p>

      </article>
      
      
    </section>
  </>
  */
}